module.exports = __webpack_public_path__ + "fonts/Austin-MediumItalic.9eb8fd01.otf";